module.exports = __webpack_public_path__ + "static/media/customer_background.6a8848f2.jpg";